import styled from 'styled-components';
import { Spacer, token } from '@zillow/constellation';

export const OutputCardContainer = styled(Spacer)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 120px;
  flex: 1;
  margin-right: 24px;
  border-radius: 5px;
  background-color: ${token('colors.coolGray100')};

  :last-of-type {
    margin-right: 0;
  }
`;
